module.exports = __webpack_public_path__ + "img/612-mini.d86e3e27.jpg";